import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { FormulaTesterComponent, Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { RequestConfigComponent } from '../request-config/request-config/request-config.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ViewChild, ElementRef } from '@angular/core';
import { UploadServices } from 'src/app/services/upload.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';


export interface Config {
  parameters: Parameter[];
  config: TableConfig[];
}

export  interface Parameter {
  PARNAME: string;
  TYPE: 'F' | 'I' | 'R' | 'J' | 'FM' | 'D' | 'S';
  requestConfig?: RequestConfig;
  VALUE?:string;
  FORMULA?:string;
  ENTITYNAME?:any;
  KEYFIELD?:any;
  VALUEFIELD?:any;
}

export  interface TableConfig {
  DATAORIG: string; // Fórmula para obter o objeto de origem (ex: FINDJSON2)
  NAME: string; // Nome da tabela
  COLUMNS: ColumnConfig[]; // Colunas da tabela
  CHILD?: TableConfig[]; // Tabelas filhas
  FILTER:any;
}


export interface RequestConfig {
  serviceName: string; // Pode ser a URL se urlType for nulo
  urlType: string | null; // null indica que serviceName é a URL
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  params: string; // Ex.: "?getFullShopeeParams({@CODECOMPANY},/api/v2/product/get_attributes)&category_id={@CATEGORY_ID}&language=pt-br"
  bodyFormula: string; // Fórmula ou valor do body
  headerFormula: string; // Fórmula ou valor do header
  codeMktp: string; // Código do marketplace
  encoding?: string; // Opcional, para métodos como getRequestDataXML
}

export  interface ColumnConfig {
  [columnName: string]: string; // Nome da coluna: Fórmula ou referência a parâmetro
}

export interface DialogData {
  entity: any;
  idInstance: any,
  instanceName:any,
  dpara: any;
}

export interface DialogResult {
  formula?: string;
  requestConfig?: RequestConfig;
}

@Component({
  selector: 'app-json-config',    
  templateUrl: './app-json-config.component.html',
  styleUrls: ['./app-json-config.component.scss'],
  standalone: false
})
export class AppJsonConfigComponent  implements OnInit { 

  constructor(
    public dialogRef: NzModalRef<AppJsonConfigComponent>,
    @Inject(NZ_MODAL_DATA) public data: DialogData, private cd:ChangeDetectorRef, private snackServices:SnackbarService,
    private uploadService: UploadServices, private sanitizer: DomSanitizer, private http:HTTPService,
    private dialogServices:DialogService, private ls: LanguageServices) {
      this.searchMktpDic.placeholder = this.ls.instant('jsoncomponent.searchValuePlaceholder');
      this.searchKeyDic.placeholder = this.ls.instant('jsoncomponent.searchKeyField');
      this.searchNameDic.placeholder = this.ls.instant('jsoncomponent.searchValueField');
    }

  config: Config = {
    parameters: [],
    config: [
      {
        DATAORIG: '',
        NAME: '',
        COLUMNS: [],
        CHILD: [],
        FILTER: ''
      }
    ]
  };
  formula:string;
  variables = [];
  configJson:any;
  selectedFile: File;
  configName:any;
  editingJson = false;
  jsonEditorText = '';
  jsonParseError: string | null = null;

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  imagePreview: any = 'assets/image/no-image-icon-round.png'; // imagem default
  files = [];

  
  ngOnInit(): void { 
      if(this.data && this.data.dpara){
        if(this.data.dpara.config != undefined){
          this.config = this.data.dpara.config;
        }

        const imgconfig = this.data?.entity?.IMGCONFIG;
        const idrule = this.data?.entity?.IDRULE;

        if(this.data?.entity?.NAME){
          this.configName = this.data?.entity?.NAME;
        }

        if(imgconfig){

          let ob = {
          entityName: 'Mktpjsonrule',
          condition: `idrule=${idrule}`,
          rows: 1,
          showImageData: true,
          showImageDataBase64: true
          }
            
          this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe(data=>{
       
          if ( ObjectUtil.isNotEmpty(data['Mktpjsonrule'][0]['IMGCONFIG'])){

              let objectURL = 'data:image/png;base64,' + data['Mktpjsonrule'][0]['IMGCONFIG'];
              this.imagePreview = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          }

          this.cd.detectChanges();
      },error=>{
          throw error;
      },()=>{
        
      });
            
    
         
      }
    }
    }

  removeColumn(table: TableConfig, column: ColumnConfig) {
    const index = table.COLUMNS.indexOf(column);
    if (index >= 0) {
      table.COLUMNS.splice(index, 1);
    }
  }
  removeTable(parentList: TableConfig[], table: TableConfig) {
    if (parentList.length <= 1) {
      // Evita remover se for a única tabela
      throw new Error(this.ls.instant('jsoncomponent.cannotRemoveLastTable'));
    }

    const index = parentList.indexOf(table);
    if (index >= 0) {
      parentList.splice(index, 1);
    }
  }

  enableJsonEdit() {
    this.jsonEditorText = this.getFormattedJSON(); 
    this.editingJson = true;
    this.jsonParseError = null;
  }

  cancelJsonEdit() {
    this.editingJson = false;
    this.jsonEditorText = '';
    this.jsonParseError = null;
  }

  applyJsonEdit() {
    try {
      const parsed = JSON.parse(this.jsonEditorText);

      
      if (!parsed.parameters || !parsed.config) {
        throw new Error(this.ls.instant('jsoncomponent.jsonMustContain'));
      }

      this.config = parsed;
      this.editingJson = false;
      this.jsonParseError = null;
    } catch (e: any) {
      this.jsonParseError = e.message;
    }
  }

  triggerImageUpload() {
    const input = this.fileInput.nativeElement;
    input.value = '';
    input.click();
  }


  handleImageUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    this.selectedFile = file;

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      this.imagePreview = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + base64);
    };
    reader.readAsDataURL(file);
  }

  copyJson(copy:boolean) {
    if (!copy) return;

    const jsonStr = this.getFormattedJSON();

    navigator.clipboard.writeText(jsonStr).then(() => {
      this.snackServices.showSuccess(this.ls.instant('jsoncomponent.jsonCopied'));
    }).catch(() => {
      this.snackServices.showError(this.ls.instant('jsoncomponent.jsonCopyError'));
    });

  }

  uploadImage(file: File) {
    const idrule = this.data?.entity?.IDRULE;
    if (!idrule) return;

    const formData = new FormData();
    formData.append('file', file, file.name);

    const payload = {
      entityName: 'Mktpjsonrule',
      datafield: 'IMGCONFIG',
      condition: `IDRULE=${idrule}`
    };

    formData.append('data', JSON.stringify(payload));

    this.uploadService.progress.subscribe(progress => {
      
    });

    this.uploadService.upLoadFile(formData);
  }



  addParameter(): void {

    this.config.parameters.push({ PARNAME: '', TYPE: 'F', requestConfig: undefined });

  }

  searchMktpDic:SearchProperties= {
                placeholder: 'Pesquisar valor...',
                size: 'large',
                showKey: true,
                disabled: false,
                entityName:'Mktpdic',
                fields:{keyField:'IDINSTANCE', valueField:'INSTANCENAME'},
  }

  searchKeyDic:SearchProperties= {
                placeholder: 'Pesquisar o Campo de Chave',
                size: 'large',
                showKey: true,
                disabled: false,
                entityName:'Mktpdiccol',
                fields:{keyField:'IDCOLUMN', valueField:'COLUMNNAME'},
  }

  searchNameDic:SearchProperties= {
                placeholder: 'Pesquisar o Campo de Descrição...',
                size: 'large',
                showKey: true,
                disabled: false,
                entityName:'Mktpdiccol',
                fields:{keyField:'IDCOLUMN', valueField:'COLUMNNAME'},
  }

  hiddenKeyField = false;
  hiddenValueField = false;

  onEntityNameChange(param: any): void {
    
    if (param.ENTITYNAME && param.ENTITYNAME.key) {
        let condition = 'IDINSTANCE = \''+param.ENTITYNAME.key+'\'';
        
        this.searchKeyDic.condition = condition;
        this.searchNameDic.condition = condition;
        
        this.hiddenKeyField = false;
        this.hiddenValueField = false;
        
    
        setTimeout(() => {
          this.hiddenKeyField = true;
          this.hiddenValueField = true;
        }, 100);  
        
    }else{
        this.hiddenKeyField = false;
        this.hiddenValueField = false;
    }
  }

  addTable(parentTable?: TableConfig): void {
    const newTable: TableConfig = {
      DATAORIG: '',
      NAME: '',
      COLUMNS: [],
      CHILD: [],
      FILTER: ''
    };
    if (parentTable) {
      parentTable.CHILD?.push(newTable);
    } else {
      this.config.config.push(newTable);
    }
  }

  onParameterTypeChange(param: Parameter, newType: string): void {
    if (newType === 'R' && !param.requestConfig) {
      param.requestConfig = {
        serviceName: '',
        urlType: null,
        method: 'GET',
        params: '',
        bodyFormula: '',
        headerFormula: '',
        codeMktp: ''
      };
    } else if (newType !== 'R' && param.requestConfig) {
      delete param.requestConfig;
    }
    this.cd.detectChanges();
  }

  openEditFormula(element, type){
    this.variables = [];

    // Pre-carrega a formula atual do elemento (antes abria sempre vazio)
    const currentFormula = type == 'D' ? element.DATAORIG : element.value;

    this.dialogServices.openGenericDialog(FormulaTesterComponent,{formula:currentFormula, variables:this.variables},(f)=>{
        if ( f['formula']){
          if(type == "D"){
            element.DATAORIG = f['formula'];
          }else{
            element.value = f['formula'];
          }
          
        }
        
    },()=>{},'80vh','80vw',false,null,'S','80px');
  }

  addColumn(table: TableConfig): void {
    table.COLUMNS.push({ columnName: '', type: 'FIXED', value: '' });
  }

  getFormattedJSON(): string {
    return JSON.stringify(this.config, null, 2);
  }
    

  openRequestConfig(param: Parameter): void {
    const variables = this.config.parameters
      .filter(p => p.PARNAME !== param.PARNAME)
      .map(p => ({ name: p.PARNAME, type: p.TYPE === 'F' ? 'fixed' : 'input' }));

    this.dialogServices.openGenericDialog(
      RequestConfigComponent, // Pode usar um diálogo personalizado, se preferir
      {
        formula: param.requestConfig?.bodyFormula || '',
        variables,
        requestConfig: param.requestConfig || {
          serviceName: '',
          urlType: null,
          method: 'GET',
          params: '',
          bodyFormula: '',
          headerFormula: '',
          codeMktp: ''
        },
        globalParams: this.config.parameters // Passa todos os parâmetros globais
      },
      (result: any) => { // Tipar o resultado
      if (result) {
        param.requestConfig = {
          serviceName: result.requestConfig?.serviceName || '',
          urlType: result.requestConfig?.urlType || null,
          method: result.requestConfig?.method || 'GET',
          params: result.requestConfig?.params || '',
          bodyFormula: result.formula || '', // Usar a fórmula do diálogo
          headerFormula: result.requestConfig?.headerFormula || '',
          codeMktp: result.requestConfig?.codeMktp || ''
        };
        this.cd.detectChanges();
      }
      },
      () => {},
      '80vh',
      '80vw',
      false,
      null,
      'S',
      '80px'
    );
  }
}
